import Vue from "vue";
import store from "./store";
import firebase from "firebase";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Register from "./views/Register.vue";
import HowItWorks from "./views/HowItWorks.vue";
import Features from "./views/Features.vue";
import Pricing from "./views/Pricing.vue";
import Dashboard from "./views/Dashboard.vue";
import Forms from "./views/Forms.vue";
import Billing from "./views/Billing.vue";
import Form from "./views/Form.vue";
import Results from "./views/Results.vue";
import Employees from "./views/Employees.vue";
import Employee from "./views/Employee.vue";
import Profile from "./views/Profile.vue";
import Locations from "./views/Locations.vue";
import Location from "./views/Location.vue";
import EmployeeRequests from "./views/EmployeeRequests.vue";
import EmployeeRequest from "./views/EmployeeRequest.vue";
import ScheduledReminders from "./views/ReminderManagement.vue";
import ScheduledReminder from "./views/ReminderManagementDetails.vue";
import Managers from "./views/Managers.vue";
import Manager from "./views/Manager.vue";
import Visitors from "./views/Visitors.vue";
import Visitor from "./views/Visitor.vue";
import PostFailureMessage from "./views/PostFailMessage.vue";
import PostNeutralMessage from "./views/PostNeutralMessage.vue";
import PostSuccessMessage from "./views/PostSuccessMessage.vue";
import Terms from "./views/Terms.vue";
import Privacy from "./views/Privacy.vue";
import ForgotPassword from "./views/ForgotPassword.vue";
import Contact from "./views/Contact.vue";
import Departments from "./views/Departments.vue";
import Schedules from "./views/Schedules.vue";
import Reporting from "./views/Reporting.vue";
import CheckIn from "./views/CheckIn.vue";
import Accounts from "./views/Accounts.vue";
import SupportTicket from "./views/SupportTicket.vue";
import SupportVideos from "./views/SupportVideos.vue";
import KioskAds from "./views/KioskAds.vue";
import KioskAd from "./views/KioskAd.vue";
import SuperAdminLogin from "./views/SuperAdminLogin.vue";

import { auth } from "./firebaseConfig";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/billing",
      name: "Billing",
      component: Billing,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/how-it-works",
      name: "HowItWorks",
      component: HowItWorks,
    },
    {
      path: "/features",
      name: "Features",
      component: Features,
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing,
    },
    {
      path: "/subscription",
      name: "subscription",
      component: Pricing,
      meta: {
        requiresAuth: true,
      },
    },

    //Contact
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
    },

    //Visitors
    {
      path: "/visitors",
      name: "Visitors",
      component: Visitors,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/visitor/:id",
      name: "Visitor",
      component: Visitor,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    //Employees

    {
      path: "/employees",
      name: "Employees",
      component: Employees,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    //Dashboard

    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    //Forms
    {
      path: "/forms",
      name: "Forms",
      component: Forms,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/form/:id",
      name: "Form",
      component: Form,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    //CheckIn

    {
      path: "/check-in",
      name: "CheckIn",
      component: CheckIn,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    //Reports
    {
      path: "/reports",
      name: "Reports",
      component: Results,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/reporting",
      name: "Reporting",
      component: Reporting,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    //Departments
    {
      path: "/departments",
      name: "Departments",
      component: Departments,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    //Settings

    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    // Locations
    {
      path: "/locations",
      name: "Locations",
      component: Locations,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/location/:id",
      name: "Location",
      component: Location,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    {
      path: "/employee-requests",
      name: "Employee Requests",
      component: EmployeeRequests,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/employee-request/:id",
      name: "Employee Request",
      component: EmployeeRequest,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    // Managers
    {
      path: "/managers",
      name: "Managers",
      component: Managers,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/manager/:id",
      name: "Manager",
      component: Manager,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },

    //Contents
    {
      path: "/post_failure_message",
      name: "Post Failure Message",
      component: PostFailureMessage,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/post_neutral_message",
      name: "Post Neutral Message",
      component: PostNeutralMessage,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/post_success_message",
      name: "Post Success Message",
      component: PostSuccessMessage,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: Privacy,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/scheduled-reminders/employees",
      name: "Schedules",
      component: Schedules,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/scheduled-reminders/visitors",
      name: "Schedules",
      component: Schedules,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/employee/:id",
      name: "Employee",
      component: Employee,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/accounts",
      name: "Accounts",
      component: Accounts,
      meta: {
        requiresAuth: true,
        requiresNoUserDoc: true,
      },
    },
    {
      path: "/reminderManagement/:id",
      name: "Reminder Schedule Details",
      component: ScheduledReminder,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/reminderManagement",
      name: "Reminder Schedule",
      component: ScheduledReminders,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/support",
      name: "Support",
      component: SupportTicket,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/videos",
      name: "Support Videos",
      component: SupportVideos,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/ads",
      name: "Kiosk Ads",
      component: KioskAds,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/ad/:id",
      name: "Kiosk Ad",
      component: KioskAd,
      meta: {
        requiresAuth: true,
        requiresPlan: true,
      },
    },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword,
    },
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/super-admin-login",
      name: "SuperAdmin Login",
      component: SuperAdminLogin,
      meta: {
        requiresSignInLink: true,
        requiresAuth: false,
        requiresPlan: false,
      },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  let currentUser = auth.currentUser;
  let requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  let requiresPlan = to.matched.some((record) => record.meta.requiresPlan);
  let requiresNoUserDoc = to.matched.some(
    (record) => record.meta.requiresNoUserDoc
  );
  let requiresSignInLink = auth.isSignInWithEmailLink(window.location.href);

  if (to.name === "SuperAdmin Login" && !requiresSignInLink) {
    next("dashboard");
  } else {
    next();
  }

  if (!requiresAuth) {
    if (currentUser) {
      next("dashboard");
    } else {
      next();
    }
  } else {
    if (currentUser) {
      if (!store.state.user_doc && requiresNoUserDoc) {
        next();
      } else if (!store.state.user_doc && !requiresNoUserDoc) {
        next("accounts");
      } else {
        if (
          requiresPlan &&
          (!store.state.user_doc.subscription ||
            !store.state.user_doc.subscription.active)
        ) {
          next("subscription");
        } else {
          next();
        }
      }
    } else {
      next("register");
    }
  }
});

export default router;
